export default {
  action: 'Hành động',
  actionBlockedDueToDuplicateUuid:
    'Hành động bị chặn do trùng lặp UUID của thiết bị',
  active: 'Đang hoạt động',
  add: 'Thêm',
  addAnotherIp: 'Thêm IP khác',
  addDeviceHeaderwoSuite: 'Thêm thiết bị: {{screen}}',
  addDevices: 'Thêm thiết bị',
  addIp: 'Thêm IP',
  addIPAddress: 'Thêm địa chỉ IP',
  addIpHeader: 'Thêm địa chỉ IP: {{screen}}',
  addRole: 'Thêm vai trò',
  addSuite: 'Thêm Suite',
  addSuiteHeader: 'Thêm Suite: {{screen}} - Suite {{suite}}',
  adminRoleWillHaveFullAccess:
    'Vai trò quản trị viên sẽ có toàn quyền truy cập',
  all: 'Tất cả',
  and: 'và',
  applianceStatus: 'Trạng thái thiết bị',
  apply: 'Áp dụng',
  assignedToDevice: 'Đã gán cho thiết bị',
  availableDevices: 'Thiết bị có sẵn',
  bookingDate: 'Ngày đặt chỗ',
  bookingRef: 'Mã đặt chỗ',
  bulkEditScreenIPs: 'Chỉnh sửa hàng loạt IP màn hình',
  bulkHeadingMsg:
    'Các thay đổi được thực hiện đối với IP ở đây sẽ được phản ánh trên tất cả các thiết bị màn hình liên kết.',
  cancel: 'Hủy',
  ccEmails: 'Email CC',
  certificateAutoSync: 'Tự động đồng bộ hóa chứng chỉ',
  certificateExpired: 'Chứng chỉ đã hết hạn',
  certificateForAllDevicesMustBeValid:
    'Chứng chỉ cho tất cả các thiết bị phải hợp lệ',
  certificateNotAvailable:
    'Chứng chỉ thiết bị không khả dụng cho số sê-ri này.',
  certificateNotValid: 'Chứng chỉ không hợp lệ',
  chain: 'Chuỗi rạp',
  chainSmall: 'Chuỗi rạp',
  changesSavedSuccessfully: 'Các thay đổi đã được lưu thành công',
  clear: 'Xóa',
  clearAll: 'Xóa tất cả',
  clearAllSmall: 'Xóa tất cả',
  clearSelection: 'Xóa lựa chọn',
  collapseAll: 'Thu gọn tất cả',
  common: {
    confirm: 'Xác nhận',
  },
  composition: 'Composition',
  compositionCount_one: 'Composition (1)',
  compositionCount_other: 'Composition ({{count}})',
  compositionDetails: 'Chi tiết bố cục',
  compositionName: 'Tên thành phần',
  confirmDelete: 'Xác nhận xóa',
  confirmDeleteIP: 'Bạn có chắc chắn muốn xóa Địa chỉ IP {{ip}} không?',
  confirmDeleteIPAssigned:
    'IP này hiện đang được gán và sẽ ngắt kết nối khỏi thiết bị: {{deviceInfo}} tại {{location}}.',
  confirmDeleteSuite:
    'Bạn có chắc chắn muốn xóa {{screen_name}} - Suite {{suite_number}} không? Vui lòng chọn tùy chọn phù hợp để tiếp tục.',
  content: 'Nội dung',
  contentDetails: 'Chi tiết nội dung',
  copyLink: 'Sao chép liên kết',
  countTheatres_one: '1 Rạp chiếu phim',
  countTheatres_other: '{{count}} Rạp chiếu phim',
  cplMarkers: 'Các điểm đánh dấu CPL',
  create: 'Tạo',
  createdOn: 'Được tạo vào',
  creditOffset: 'Bù trừ tín dụng',
  creditsOffset: 'Bù trừ tín dụng',
  dcpStatusTitle: 'Trạng thái DCP',
  deactivatedUser: 'Người dùng đã bị vô hiệu hóa',
  delete: 'Xóa',
  deleteIp: 'Xóa IP',
  deleteSuite: 'Xóa Suite',
  deleteTheatreGroup: 'Xóa nhóm rạp chiếu phim',
  deleteTheatreGroupConfirmation:
    'Bạn có chắc chắn muốn xóa {{groupName}} không? Hành động này là vĩnh viễn và không thể hoàn tác.',
  deleteTheatreWarningMessage:
    'Xóa nó sẽ ảnh hưởng đến quyền truy cập của họ, Bạn có chắc chắn muốn tiếp tục không?',
  details: 'Chi tiết',
  deviceWillBeRemoved: 'Thiết bị sẽ bị xóa khỏi suite này',
  deviceModel: 'Mô hình thiết bị',
  deviceRole: 'Vai trò thiết bị',
  devices: 'Thiết bị',
  deviceWillBeMoved:
    'Thiết bị sẽ được chuyển sang Thiết bị màn hình {{destination}} sau khi lưu',
  deviceWillBeMovedToStandby: 'Thiết bị sẽ được chuyển sang chế độ Chờ',
  disabled: 'Đã tắt',
  doNotIncludePrDevices: 'KHÔNG bao gồm các thiết bị PR để tạo KDM.',
  downloadAttempt: 'Nỗ lực tải xuống',
  downloadDetails: 'Chi tiết tải xuống',
  downloadHistory: 'Lịch sử tải xuống',
  downloadKDMs: 'Tải xuống KDM',
  downloadLocation: 'Vị trí tải xuống',
  downloadNow: 'Tải xuống ngay',
  downloadProgress: '{{progress}} Đã hoàn thành',
  downloadSize: 'Kích thước tải xuống',
  downloadStatus: 'Trạng thái tải xuống',
  duplicateDeviceFound: 'Phát hiện thiết bị trùng lặp',
  duplicateDeviceWarning:
    'Tìm thấy thiết bị trùng lặp trong {{screens_and_suites}}',
  editDevice: 'Chỉnh sửa thiết bị',
  editDeviceMeta: 'Chỉnh sửa siêu dữ liệu thiết bị',
  editIp: 'Chỉnh sửa IP',
  editIpHeader: 'Chỉnh sửa IP - Màn hình {{screen}}',
  editRoles: 'Chỉnh sửa vai trò',
  editSuite: 'Chỉnh sửa Suite',
  editSuiteHeader: 'Chỉnh sửa Suite: Màn hình {{screen}} - Suite {{suite}}',
  editTheatreGroup: 'Chỉnh sửa nhóm rạp chiếu phim',
  effectiveFrom: 'Có hiệu lực từ',
  email: 'Email',
  emailKDMS: 'Email KDMs',
  emptyScreen: 'Không có suite nào được thêm vào màn hình',
  emptyStandby: 'Không có thiết bị nào ở chế độ chờ',
  enabled: 'Đã bật',
  enterEmail: 'Nhập email',
  enterGateway: 'Nhập Gateway',
  enterIpAddress: 'Nhập địa chỉ IP',
  enterSoftwareVersion: 'Nhập phiên bản phần mềm',
  enterSubnetMask: 'Nhập Subnet Mask',
  errorDownloadingKDMs: 'Lỗi khi tải xuống KDM',
  errorFetching: 'Lỗi khi tải dữ liệu',
  errorFetchingDevices: 'Lỗi khi tải danh sách thiết bị',
  errorFetchingFilterSettings: 'Lỗi khi tải cài đặt bộ lọc',
  errorFetchingGroups: 'Lỗi khi tải danh sách nhóm',
  errorFetchingUser: 'Lỗi khi tải thông tin người dùng',
  errorFetchingUsersList: 'Lỗi khi tải danh sách người dùng',
  errorFetchingWireTapCount: 'Lỗi khi tải tổng số lượng WireTAP',
  errorLoadingWireTap: 'Lỗi khi tải WireTAP',
  errorMessage: 'Đã xảy ra lỗi trong khi xử lý yêu cầu của bạn',
  errorReportDownload: 'Lỗi khi tải xuống báo cáo {{report}}: {{error}}',
  errors: {
    fetchDeviceModels: 'Lỗi khi tải mẫu thiết bị',
    fetchDeviceRoles: 'Lỗi khi tải vai trò thiết bị',
    fetchTheatreInfo: 'Lỗi khi tải thông tin rạp chiếu phim',
  },
  errorUploadingCertificate: 'Lỗi khi tải lên chứng chỉ',
  expandAll: 'Mở rộng tất cả',
  expired: 'Đã hết hạn',
  expiredOn: 'Đã hết hạn vào',
  expiring: 'Sắp hết hạn (trong {{days}} ngày)',
  expiring_1: 'Sắp hết hạn',
  expiryOn: 'Hết hạn vào',
  failedToDeleteTheatreGroup: 'Không thể xóa nhóm rạp chiếu phim',
  failedToDeleteTheatreGroupMessage:
    'Đã xảy ra lỗi khi xóa nhóm rạp chiếu phim',
  failedToRemoveUser: 'Không thể xóa người dùng',
  failedToSendUserInvite: 'Không thể gửi lời mời người dùng',
  failedToUpdateUser: 'Không thể cập nhật người dùng',
  fetchCompositions: 'Lỗi khi tải các bố cục',
  fetchingRoles: 'Đang tải vai trò...',
  fetchTheatres: 'Lỗi khi tải danh sách rạp chiếu phim',
  filter: 'Bộ lọc',
  filterBy: 'Lọc theo',
  filterByTheatres: 'Lọc theo rạp chiếu phim',
  filterPanelCompositionType: 'LOẠI COMPOSITION',
  filterPanelCompositionTypeOptions_advertisement: 'Quảng cáo',
  filterPanelCompositionTypeOptions_feature: 'Tính năng/Các tính năng',
  filterPanelCompositionTypeOptions_others: 'Khác',
  filterPanelCompositionTypeOptions_psaPolicy: 'PSA/Chính sách',
  filterPanelCompositionTypeOptions_trailerTeaserPromo: 'Trailer/Teaser/Promo',
  filterPanelDcpDownloadStatus: 'TRẠNG THÁI TẢI DƯ LIỆU DCP',
  filterPanelDcpIngestStatus: 'TRẠNG THÁI NHẬP DỮ LIỆU DCP',
  filterPanelKdmIngestStatus: 'TRẠNG THÁI NHẬP DỮ LIỆU KDM',
  filterPanelKdmStatus: 'TRẠNG THÁI PHÂN PHỐI KDM',
  filterPanelKdmValidity: 'TÍNH HỢP LỆ CỦA KDM',
  filterPanelTheatresPlaceHolder: 'Tìm kiếm rạp chiếu phim',
  filterPanelTheatresTitle: 'RẠP CHIẾU PHIM',
  filters: 'Bộ lọc',
  from_time_of_booking: 'kể từ thời điểm đặt chỗ.',
  fullAccess: 'Toàn quyền truy cập',
  future: 'Có hiệu lực trong tương lai',
  gateway: 'Gateway',
  generateReport: 'Tạo báo cáo',
  groupCount_one: '{{count}} Nhóm',
  groupCount_other: '{{count}} Nhóm',
  groupName: 'Tên nhóm',
  groupsCreateGroupCancel: 'Hủy',
  groupsCreateGroupCreateTheatreGroups: 'Tạo nhóm rạp chiếu phim',
  groupsCreateGroupGroupCreated: 'Nhóm đã được tạo',
  groupsCreateGroupGroupName: 'Tên nhóm',
  groupsCreateGroupGroupPlaceHolderName: 'Nhập tên nhóm',
  groupsCreateGroupHeaderTitle: 'Tạo nhóm',
  groupsCreateGroupSaveChanges: 'Lưu thay đổi',
  groupsCreateGroupTheatreSelection: 'Lựa chọn rạp chiếu phim',
  groupsHeaderCreateTheatreGroupButton: 'Tạo nhóm rạp chiếu phim',
  groupsHeaderViewLogsButton: 'Xem nhật ký',
  groupUpdated: 'Nhóm đã được cập nhật',
  holdoverKdmRequests: 'Yêu cầu Holdover KDM',
  hour: 'Giờ',
  iabScreens: 'Màn hình IAB',
  inbox: 'Hộp thư đến',
  invalidEmail: 'Địa chỉ email không hợp lệ',
  ipRequired: 'Địa chỉ IP là bắt buộc',
  ipAddress: 'Địa chỉ IP',
  ipAddress_1: 'ĐỊA CHỈ IP',
  ipAlreadySelectedInForm: 'IP này đã được chọn/gán. Vui lòng chọn IP khác.',
  ipCount_one: 'IP (1)',
  ipCount_other: 'IP ({{count}})',
  kdmDetails: 'Chi tiết KDM',
  kdmValidityTheatreTimeZone: 'Tính hợp lệ của KDM (Múi giờ rạp chiếu phim)',
  lastUpdatedBy: 'Lần cập nhật cuối cùng bởi',
  lastUpdatedOn: 'Cập nhật lần cuối vào',
  linkExpiredOnDownload:
    'Không thể bắt đầu tải xuống. Liên kết giao hàng đã hết hạn hoặc không còn đủ điều kiện để tải xuống.',
  linkReceivedOn: 'Liên kết đã nhận vào',
  loading: 'Đang tải',
  location: 'Vị trí',
  logsTheatreGroups: 'Nhật ký: Nhóm rạp chiếu phim',
  minute: 'Phút',
  moveModalText: 'Thiết bị {{name}} sẽ được chuyển sang chế độ chờ, tiếp tục?',
  moveTo: 'Chuyển đến',
  moveToScreen: 'Màn hình {{number}}',
  moveToStandby: 'Chuyển sang chế độ Chờ',
  moveToStandbyDevices: 'Chuyển sang Thiết bị chờ',
  moveToUnmapped: 'Chuyển sang Thiết bị màn hình {{number}}',
  movie: 'Phim',
  movieName: 'Tên phim',
  multiThumbprintKdm:
    'Màn hình KDM Multi Thumbprint với máy chủ DC2 (DCP 2000)',
  multiThumbprintKdmOtherServices:
    'Màn hình KDM Multi Thumbprint với các máy chủ khác',
  name: 'Tên',
  needs_1_SM_RMB_msg:
    'Mỗi suite phải chứa chính xác 1 SM/1 RMB. Vui lòng thêm thiết bị SM/RMB kèm chứng chỉ để tiếp tục',
  newData: 'Dữ liệu mới',
  newRequestCreated: 'Yêu cầu mới đã được tạo với Mã yêu cầu {{requestId}}.',
  no_compositions: 'Không có bố cục',
  no_theatres: 'Không có rạp chiếu phim khả dụng',
  noAccess: 'Không có quyền truy cập',
  noBookings: 'Không có đặt chỗ nào',
  noData: 'Không có dữ liệu',
  noExpiredBookings: 'Không tìm thấy lượt tải xuống WireLink đã hết hạn.',
  noIpFound: 'Không có IP khả dụng',
  noMatchFound: 'Không tìm thấy kết quả phù hợp',
  noResultsFound: 'Không tìm thấy kết quả',
  normalKdm: 'KDM thông thường',
  notDownloaded: 'Chưa tải xuống',
  notSelected: 'Chưa được chọn',
  noWiretapAvailable: 'Không có WireTAP khả dụng',
  oldData: 'Dữ liệu cũ',
  optional: 'Tùy chọn',
  osVersion: 'Phiên bản hệ điều hành',
  pending: 'Đang chờ xử lý',
  readyToDownload: 'Sẵn sàng tải xuống',
  receivedOn: 'Đã nhận vào',
  recipientDetails: 'Chi tiết người nhận',
  recipientEmails: 'Email người nhận',
  remove: 'Xóa',
  removeFromTheatre: 'Xóa khỏi rạp chiếu phim',
  removeModalText:
    'Bạn có chắc chắn muốn xóa {{name}} khỏi rạp chiếu phim không?',
  removeUser: 'Xóa người dùng',
  removeUserConfirmation:
    'Xóa người dùng này sẽ loại bỏ quyền truy cập của họ khỏi công ty này. Người dùng không thể đăng nhập hoặc thực hiện bất kỳ hành động nào.',
  reportInitiated: '{{report}} đã được khởi tạo.',
  reportReady: '{{report}} đã sẵn sàng.',
  reportsheaderTitle: 'Báo cáo',
  requestedBy: 'Được yêu cầu bởi',
  requestedKdmValidity: 'Yêu cầu xác thực KDM',
  requestedOn: 'Đã yêu cầu',
  requestFailed: 'Yêu cầu thất bại',
  requestFailedMessage: 'Không thể gửi yêu cầu. Vui lòng thử lại.',
  requestSent: 'Đã gửi yêu cầu',
  role: 'Vai trò',
  roles: 'Vai trò',
  save: 'Lưu',
  saveChanges: 'Lưu thay đổi',
  screen: 'Màn hình',
  screenInactive: 'Không hoạt động',
  screens: 'Màn hình',
  searchByLocation: 'Tìm kiếm theo Vị trí',
  searchByNameOrEmail: 'Tìm kiếm theo Tên hoặc Email',
  searchBySerialNo: 'Tìm kiếm theo Số sê-ri',
  searchByTheatreGroup: 'Tìm kiếm theo Nhóm rạp chiếu phim',
  searchByTheatreGroupName: 'Tìm kiếm theo Tên nhóm rạp chiếu phim',
  searchByTheatreName: 'Tìm kiếm theo Tên rạp chiếu phim',
  searchCompositions: 'Tìm kiếm theo Tên thành phần',
  searchCompositionsPlaceholder: 'Tìm kiếm Composition',
  searchDeviceModel: 'Tìm kiếm Mẫu thiết bị',
  searchForChain: 'Tìm kiếm Chuỗi rạp',
  searchForLocation: 'Tìm kiếm Vị trí',
  searchForOsVersion: 'Tìm kiếm Phiên bản hệ điều hành',
  searchForPublicIp: 'Tìm kiếm IP công cộng',
  searchForSerialNumber: 'Tìm kiếm Số sê-ri',
  searchForTheatre: 'Tìm kiếm Rạp chiếu phim',
  searchForWiretap: 'Tìm kiếm WireTAP',
  searchMovies: 'Tìm kiếm theo Tên phim',
  searchPlaceholder: 'Tìm kiếm các rạp chiếu phim bạn quản lý',
  searchSerialNumber: 'Tìm kiếm Số sê-ri',
  searchTheatres: 'Tìm kiếm theo Tên rạp chiếu phim',
  selectIpAddress: 'Chọn địa chỉ IP',
  selectRole: 'Chọn vai trò',
  sendInvite: 'Gửi lời mời',
  serialNumber: 'Số sê-ri',
  serialNumber_1: 'SỐ SÊ-RI',
  show: 'Hiển thị',
  showingCountResults_one: 'Hiển thị 1 kết quả cho',
  showingCountResults_other: 'Hiển thị {{count}} kết quả cho',
  showingResults: 'Hiển thị {{start}}-{{end}} trong tổng số {{total}} mục',
  showingResultsFor: 'Hiển thị kết quả cho',
  showMore: 'Hiển thị thêm',
  softwareVersion: 'Phiên bản phần mềm',
  somethingWentWrong: 'Đã xảy ra lỗi',
  standby: 'Chế độ chờ',
  standbyDevices: 'Thiết bị chờ',
  standbyHeader_one: 'Thiết bị chờ (1)',
  standbyHeader_other: 'Thiết bị chờ ({{count}})',
  status: 'Trạng thái',
  subnetMask: 'Subnet Mask',
  suite: 'Suite',
  suiteCreationRules: 'Quy tắc tạo Suite',
  suiteDevicesExpiredMsg: 'Suite có thiết bị với chứng chỉ đã hết hạn',
  suiteEffectiveFrom: 'Suite có hiệu lực từ',
  suiteInvalid: 'Suite không hợp lệ để tạo KDM',
  suiteLogs: 'Nhật ký Suite',
  suiteMustContain:
    'Suite phải chứa chính xác {{smCount}} thiết bị SM hoặc {{rmbCount}} thiết bị RMB.',
  suiteMustContainAdLd:
    'Suite phải chứa ít nhất 1 thiết bị bổ sung với Vai trò thiết bị là LD',
  suiteMustContainLDorPR:
    'Suite phải chứa ít nhất 1 thiết bị bổ sung với Vai trò thiết bị là LD hoặc PR.',
  suiteMustContainSm: 'Suite phải chứa chính xác {{smCount}} thiết bị SM.',
  suiteMustContainSMOBE:
    'Suite phải chứa chính xác 1 SM / OBAE với thiết bị SM.',
  suiteNo: 'Suite {{number}}',
  theatre: 'Rạp chiếu phim',
  theatre_1: 'RẠP CHIẾU PHIM',
  theatre_header: 'Rạp chiếu phim',
  theatreCount: 'Số lượng rạp chiếu phim',
  theatreGroup: 'Nhóm rạp chiếu phim',
  theatreGroupDeleted: 'Nhóm rạp chiếu phim đã bị xóa',
  theatreGroupDeletedMessage: '{{groupName}} đã bị xóa',
  theatreGroupDetails: 'Chi tiết nhóm rạp chiếu phim',
  theatreGroups: 'Nhóm rạp chiếu phim',
  theatreName: 'Tên rạp chiếu phim',
  theatres: 'Rạp chiếu phim',
  theatresList: 'Danh sách rạp chiếu phim',
  theatreSmall: 'Rạp chiếu phim',
  theatreTimeZone: 'Múi giờ rạp chiếu phim',
  trackingInfo: 'Thông tin theo dõi',
  unarchival_may_take: 'Quá trình giải nén có thể mất',
  undo: 'Hoàn tác',
  unmappedDevices_one: 'Thiết bị (1)',
  unmappedDevices_other: 'Thiết bị ({{count}})',
  untitled: 'Không có tiêu đề',
  update: 'Cập nhật',
  updatedBy: 'Được cập nhật bởi',
  updatedOn: 'Cập nhật vào',
  uploadCertificate: 'Tải lên chứng chỉ',
  uploadDeviceCertificate: 'Tải lên chứng chỉ thiết bị',
  user: 'Người dùng',
  userCount_one: '{{1}} Người dùng',
  userCount_other: '{{count}} Người dùng',
  userInviteSent: 'Đã gửi lời mời người dùng thành công',
  userLogs: 'Nhật ký người dùng',
  userRemoved: 'Người dùng đã bị xóa',
  users: 'Người dùng',
  usersHeaderButtonsInviteUser: 'Mời người dùng',
  usersHeaderButtonsViewLogs: 'Xem nhật ký',
  usersHeaderTitle: 'Quản lý người dùng',
  validFrom: 'Có hiệu lực từ',
  validNow: 'Có hiệu lực bây giờ',
  validTo: 'Có hiệu lực đến',
  verificationStatus: 'Trạng thái xác minh',
  viewAll: 'Xem tất cả',
  viewAllTheatreGroups: 'Xem tất cả các nhóm rạp chiếu phim',
  viewCreditOffset: 'Tín dụng: {{value}}',
  viewSuiteLogs: 'Xem nhật ký Suite',
  viewTheatreGroup: 'Xem nhóm rạp chiếu phim',
  warning: 'Cảnh báo',
  wireLinkCopiedToClipboard: 'WireLink đã được sao chép vào khay nhớ tạm',
  wireLinkCopyFailed: 'Không thể sao chép, Vui lòng thử lại',
  wireLinkDetails: 'Chi tiết WireLink',
  wireLinks: 'WireLinks',
  wiretaps: 'WireTAPs',
  wiretapStatusReport: 'Báo cáo trạng thái WireTAP',
  removeDevice: 'Xóa thiết bị',
  deleteIpTitle: 'Xóa địa chỉ IP - {{ip}}',
  appliances: 'Thiết bị',
  noResultsFor: 'Không có kết quả cho',
  city: 'Thành phố',
  province: 'Tỉnh',
  country: 'Quốc gia',
  confirmAction: 'Xác nhận hành động',
  RequestId: 'ID yêu cầu: {{requestId}}',
  moveToUnmapped_name: 'Chuyển đến thiết bị {{name}}',
  language: 'Ngôn ngữ',
  subtitleLanguage: 'Ngôn ngữ phụ đề',
  mainCaption: 'Phụ đề chính',
  ratings: 'Đánh giá',
  type: 'Loại',
  dciStandard: 'Tiêu chuẩn DCI',
  closedSubtitles: 'Phụ đề đóng',
  frameRate: 'Tốc độ khung hình',
  audioFormats: 'Định dạng âm thanh',
  resolution: 'Độ phân giải',
  closedCaptions: 'Phụ đề đóng',
  stereoType: 'Loại âm thanh nổi',
  aspectRatio: 'Tỷ lệ khung hình',
};
